import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalManagerSelectComponent } from './modal-manager-select.component';
import { CheckListModule } from '../../../shared/data-filter/check-list/check-list.module';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from '../accordion/accordion.module';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ModalModule } from '../../../controls/modal/modal.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CheckListModule,
    AccordionModule,
    RadioButtonModule,
    ModalModule,
  ],
  declarations: [ModalManagerSelectComponent],
  exports: [ModalManagerSelectComponent]
})
export class ModalManagerSelectModule { }
